import {Component, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {Branch, BranchInitState} from '@/store/branch/branch.types';
import {Community, CommunityInitState, FilterCommunity} from '@/store/community/community.types';
import {MemberServiceType, ServiceFormSearch, ServiceSearchComponentInterface} from '@/class/service-form.interface';
import {Service, ServiceInitState} from '@/store/service/service.types';
import {FilterSubService, SubService, SubServiceInitState} from '@/store/subservice/subservice.types';
import {MemberInitState} from '@/store/member/member.types';
import {Toast} from '@/store/toast/toast.types';
import {FormValidate} from '@/services/form-validate';

@Component({
  components: {}
})
export default class ServiceSearchComponent extends Vue implements ServiceSearchComponentInterface {
  @State('branch') branchInitState!: BranchInitState;
  @State('community') communityInitState!: CommunityInitState;
  @State('service') serviceInitState!: ServiceInitState;
  @State('subService') subServiceInitState!: SubServiceInitState;
  @State('member') memberState!: MemberInitState;

  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getBranch', {namespace: 'branch'}) getBranch!: () => Promise<void>;
  @Action('_getCommunity', {namespace: 'community'}) getCommunity!: (filter?: FilterCommunity) => Promise<void>;
  @Action('_getService', {namespace: 'service'}) getService!: () => Promise<void>;
  @Action('_getSubService', {namespace: 'subService'}) getSubService!: (filter?: FilterSubService) => Promise<void>
  @Action('_getMemberFromService', {namespace: 'member'}) getMemberFromService!: (filter: ServiceFormSearch) => Promise<void>
  @Action('_setFormSearch', {namespace: 'member'}) setFormSearch!: (filter: ServiceFormSearch) => Promise<void>
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  public days = [
    {
      th: 'อาทิตย์',
      value: '1'
    },
    {
      th: 'จันทร์',
      value: '2'
    },
    {
      th: 'อังคาร',
      value: '3'
    },
    {
      th: 'พุธ',
      value: '4'
    },
    {
      th: 'พฤหัสบดี',
      value: '5'
    },
    {
      th: 'ศุกร์',
      value: '6'
    },
    {
      th: 'เสาร์',
      value: '7'
    }
  ];
  public communities = [] as Community[];
  public branchList = [] as Branch[];
  public serviceFormSearch: ServiceFormSearch = {
    serviceId: null,
    branchId: null,
    subServiceId: null,
    communityId: null,
    days: [],
    serviceType: MemberServiceType.ServiceReceiver,
    crossBranch: false
  };
  public services = [] as Service[];
  public subServices = [] as SubService[];
  public filterSubService = {} as FilterSubService;
  public filterCommunity = {} as FilterCommunity;
  public serviceType: number = 1;
  public disabledBranch = false;

  @Watch('$route.query')
  queryChange(val: string) {
    this.fetchServiceType();
  }

  async mounted() {
    this.Loading(true);
    this.fetchServiceType();
    await this.getBranch();
    await this.getService();
    this.branchList = this.branchInitState.branchs;
    this.services = this.serviceInitState.service;
    this.Loading(false);
  }

  fetchServiceType() {
    let {serviceType} = this.$route.query;
    this.serviceType = parseInt(serviceType as string);
    this.serviceFormSearch.serviceType = this.serviceType === 1 ? MemberServiceType.ServiceProvider : MemberServiceType.ServiceReceiver;

  }

  async fetchSubService() {
    await this.getSubService(this.filterSubService);
    this.subServices = this.subServiceInitState.subService;
  }

  async fetchCommunity() {
    await this.getCommunity(this.filterCommunity);
    this.communities = this.communityInitState.community;
  }

  async serviceChanged() {
    this.Loading(true);
    this.filterSubService.serviceId = this.serviceFormSearch.serviceId || '';
    await this.fetchSubService();
    this.Loading(false);
  }

  async branchChanged() {
    this.Loading(true);
    this.filterCommunity.branchId = this.serviceFormSearch.branchId || '';
    await this.fetchCommunity();
    this.Loading(false);
  }

  async submitServiceSearch() {
    let forms = document.getElementsByClassName('serviceServiceForm');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }
    this.Loading(true);
    await this.getMemberFromService(this.serviceFormSearch);
    if (this.memberState.getMemberFromService.length) {
      await this.setFormSearch(this.serviceFormSearch);
      this.$emit('searched', this)
    } else {
      this.Toast({
        heading: '!',
        message: 'ไม่พบผลลัพธ์ ตามรายการที่ท่านค้นหา',
        type: 'warning'
      }).then();
    }
    this.Loading(false);
  }

  resetServiceSearch() {
    this.serviceFormSearch = {
      serviceId: null,
      branchId: null,
      subServiceId: null,
      communityId: null,
      days: [],
      serviceType: MemberServiceType.ServiceReceiver,
      crossBranch: false
    };
    this.subServices = [];
    this.fetchServiceType();
  }

  actionCrossBranch() {
    if(!this.serviceFormSearch.crossBranch) {
      this.serviceFormSearch.branchId = null;
      this.serviceFormSearch.communityId = null;
    }
  }

}


